'use client'
import { FC, useEffect, useState } from 'react'
import { Link } from 'react-scroll'

import { items } from '@/components/Navbar/Items'
import { menuItems } from '@/components/Navbar/Navbar.style'
import Image from 'next/image'

const NavBar: FC = () => {
  const [scrollPosition, setScrollPosition] = useState(0)
  const [openMenu, setOpenMenu] = useState(false)
  const [partner, setPartner] = useState<Record<string, string>>()

  const handleScroll = () => setScrollPosition(window.pageYOffset)

  // Usado para alterar a cor do menu ao rolar a página
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1280px)') // Defina o breakpoint desejado
    const handleMediaChange = (event: MediaQueryListEvent) => {
      setOpenMenu(event.matches)
    }

    // Configura o estado inicial
    setOpenMenu(mediaQuery.matches)

    // Ouve as mudanças de largura
    mediaQuery.addEventListener('change', handleMediaChange)

    // Cleanup listener
    return () => mediaQuery.removeEventListener('change', handleMediaChange)
  }, [])

  useEffect(() => {
    localStorage.removeItem('partner')
    const loadPartner = () => {
      const storedPartner = localStorage.getItem('partner')
      if (storedPartner) {
        setPartner(JSON.parse(storedPartner))
      }
    }

    window.addEventListener('partnerUpdated', loadPartner)
    loadPartner() // Carrega inicialmente

    return () => {
      window.removeEventListener('partnerUpdated', loadPartner)
    }
  }, [])

  return (
    <header>
      <nav
        className={`bg-background fixed inset-x-0 top-0 z-50 flex justify-center transition-all duration-700 ${scrollPosition > 200 ? 'mt-2' : 'mt-8'}`}
      >
        <div
          className={`container w-[90%] items-center justify-between rounded-lg p-6 backdrop-blur-lg transition-all duration-700 ease-in-out xl:flex ${scrollPosition > 200 ? 'bg-teal-800 bg-opacity-80' : 'bg-white bg-opacity-30 text-xs lg:text-base'}`}
        >
          <div className="flex justify-between">
            <div className="flex flex-col gap-4 sm:flex-row">
              <Link
                activeClass="item-menu-active"
                key="logo"
                to="home"
                className="cursor-pointer text-white hover:text-gray-200"
                spy={true}
                smooth={true}
                duration={500}
                offset={-90}
                delay={0}
                onClick={() => setOpenMenu(true)}
              >
                <Image
                  src="/img/logo-bc-energia.svg"
                  alt="BC Energia"
                  width={160}
                  height={25}
                  priority
                />
              </Link>
              {partner && partner.Link_Logo_Parceiro__c && (
                <div className="flex items-center">
                  <Image
                    src={partner.Link_Logo_Parceiro__c}
                    alt={partner.Name as string}
                    width={160}
                    height={25}
                    priority
                  />
                </div>
              )}
            </div>

            <div className="xl:hidden" onClick={() => setOpenMenu(!openMenu)}>
              <Image src="/img/menu.svg" alt="BC Energia" width={30} height={30} priority />
            </div>
          </div>
          <div className={menuItems({ openMenu })}>
            {items.map((item) => (
              <Link
                activeClass="item-menu-active"
                key={item.id}
                to={item.target}
                className="m-0 cursor-pointer text-white hover:text-gray-200"
                spy={true}
                smooth={true}
                duration={500}
                offset={-90}
                delay={0}
                onClick={() => setOpenMenu(false)}
              >
                {item.title}
              </Link>
            ))}
            <Link
              activeClass="item-menu-active"
              to="economizar"
              className="text-md cursor-pointer rounded bg-amber-400 px-4 py-2 text-center text-teal-900 hover:bg-amber-500 hover:text-teal-900 lg:px-10 lg:py-3 lg:text-lg"
              spy={true}
              smooth={true}
              duration={500}
              offset={-90}
              delay={0}
              onClick={() => setOpenMenu(false)}
            >
              Contrate Agora
            </Link>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default NavBar
